var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo_wrap"},[_c('router-link',{staticClass:"logo",attrs:{"to":this.$store.getters.lang ? '/' + this.$store.getters.lang : '/',"active-class":"","title":"AppTown"}},[_c('span',{staticClass:"logo_text_wrap"},[_c('span',{staticClass:"title"},[_vm._v("AppTown")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }